
/**
 * 動態的 gadget，會依設定決定 gadget 內容。
 */
export const DynamicGadgetGUID = 'AEC98CE7-B31F-424F-B1A3-BB10012BB704';

export type GadgetArchitecture = 'web2' | 'popup' | 'web2proxy' | 'web2remoteagent' | 'web3' | 'web3builtin' | 'web3core';

export class GadgetMetadata {
  guid: string;
  title: any;
  icon: string;
  popupURL?: string;
  architecture: GadgetArchitecture;
  integrationMethod: string;

  private constructor() {}

  public static create(rec: Partial<GadgetMetadata>) {
    return Object.assign(new GadgetMetadata(), rec);
  }

  getIconURL(params: any) {
    if (this.specialGuid() === 'popupGadget') {
      const config = this.parseParams(params)
      return config.icon;
    } else {
      return this.icon;
    }
  }

  getTitle(lang: Language, params: any) {
    if (this.specialGuid() === 'popupGadget') {
      const config = this.parseParams(params);
      return config.title || '';
    } else {
      return this.title ? this.title[lang] : '';
    }
  }

  isPopup() {
    if (this.specialGuid() === 'popupGadget') {
      return true;
    } else {
      return (this.popupURL) ? true : false;
    }
  }

  getURL(dsns: string, targetTitle: string, params: any, id: string = '') {
    if (this.specialGuid() === 'popupGadget') {
      const config = this.parseParams(params);
      return config.popup || '';
    } else {
      let alternative_link = null;
      try {
        const config = this.parseParams(params);
        alternative_link = config.alternative_link;
      } catch { }

      // 先看有沒有該校有沒有特別的 url，再看預設的設定，最後再走 web2。
      return alternative_link || this.popupURL || [
        `https://legacy-web2.ischool.com.tw/embed`,
        `?full-gadget=true`,
        `${(params !== '{}') ? '&paramValues=' + params : ''}`,
        `#${dsns}_${targetTitle}_${id || this.guid}`
      ].join('');
    }
  }

  getGuid() {
    return this.guid;
  }

  getArchitecuture() {
    return this.architecture;
  }

  getIntegrationMethod(params: any) {
    if (this.specialGuid() === 'popupGadget') {
      const config = this.parseParams(params);
      return config.integration_method || 'ischool_auth';
    } else {
      return this.integrationMethod;
    }
  }

  private specialGuid() {
    // 共用型超連結 gadget
    if (this.guid === DynamicGadgetGUID) {
      return 'popupGadget';
    }
  }

  private parseParams(params: any) {
    try { // 因為某些原因，需要 Parse 兩次。
      return params as any;
    } catch {
      return {};
    }
  }
}
